document.addEventListener('DOMContentLoaded', function () {
  addCareerHeaderArrowEvent()
  addCareerHeaderVideoBtn()
})

function addCareerHeaderArrowEvent () {
  const mediaTypeInput = document.querySelector('#header-content__media-type')
  const arrowButtons = document.querySelector('.downArrows')

  if (!mediaTypeInput || !arrowButtons) return

  const mediaType = mediaTypeInput.value || ''

  // Deactivate scroll down if the header is not an image
  if (mediaType !== 'image') {
    arrowButtons.style.cursor = 'default'
    return
  }

  const pageContent = document.querySelector('.career-landing-page__content')

  if (!pageContent) return

  arrowButtons.addEventListener('click', function () {
    pageContent.scrollIntoView({ behavior: 'smooth' })
  })
}

function addCareerHeaderVideoBtn () {
  const thumbnail = document.querySelector('.header-content__image')
  const videoBtn = document.querySelector('.header-content__media .btn--video')

  const internalVideo = document.querySelector('.header-content__media video')
  const externalVideo = document.querySelector('.header-content__media iframe')

  if (!videoBtn || !thumbnail) return

  videoBtn.addEventListener('click', function () {
    thumbnail.classList.add('hidden')
    videoBtn.style.display = 'none'
    if (internalVideo) {
      internalVideo.classList.remove('hidden')
    }
    if (externalVideo) {
      externalVideo.classList.remove('hidden')
    }
  })
}
